import { ConfiguratorTreeItemModel } from "src/api/generated/erp/configurator/configuratorTree/configuratorTreeItemModel.ts";
import { getTreeItemRecursiveConfiguratorInput } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/treeItemModel/configuratorTreeItemQueries.ts";
import { PartConfiguratorFormApi } from "src/api/generated/erp/configurator/api/partConfiguratorFormApi.ts";
import { PartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/partConfiguratorType.ts";
import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues.ts";
import { PartConfiguratorTreeResult } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/PartConfiguratorTreeStatefulView.tsx";

/**
 * The property values of a configurator result for viewing it without saving: those the component form resolved, or
 * for a property-model form those resolved on the server from its input.
 */
export async function resolvePartConfiguratorTreeResultValues(
	configuratorType: PartConfiguratorType,
	result: PartConfiguratorTreeResult,
): Promise<ConfigurationPropertyValues> {
	if (result.propertyValues != null) return result.propertyValues;
	const { propertyValues } = await PartConfiguratorFormApi.resolvePropertyModelState({
		configurationSessionId: result.configurationSessionId,
		configuratorType,
		propertyInputValues: result.propertyInputValues ?? {},
	});
	return propertyValues;
}

/** The values of a component form's tree, e.g. for a printout of a test configuration. */
export async function resolveComponentTreePropertyValues(
	rootConfiguratorItem: ConfiguratorTreeItemModel,
): Promise<ConfigurationPropertyValues> {
	const resolvedState = await PartConfiguratorFormApi.resolveConfiguratorState({
		configurationSessionId: rootConfiguratorItem.configurationSessionId,
		configuratorType: rootConfiguratorItem.configuratorType,
		configuratorInput: getTreeItemRecursiveConfiguratorInput(rootConfiguratorItem),
		resolveRecursively: true,
	});
	return resolvedState.propertyValues;
}
